var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9616",
    "data-name": "Group 9616",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32.067,
    viewBox: "0 0 32 32.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.343,
    y1: 0.053,
    x2: 0.758,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07e25"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M28.427,0A16.044,16.044,0,0,1,44.494,16.068V17.1a2.908,2.908,0,0,1-2.472,1.579,2.844,2.844,0,0,1-2.609-1.82v-.79a10.849,10.849,0,1,0-21.7,0,10.528,10.528,0,0,0,2.747,7.176A3.025,3.025,0,0,1,19.294,26.5a2.973,2.973,0,0,1-2.747.137A16.189,16.189,0,0,1,12.5,16.068,15.842,15.842,0,0,1,28.427,0",
    transform: "translate(-12.494 0)",
    fill: "#f07e25",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    d: "M28.568,41.953A16.044,16.044,0,0,1,12.5,25.885v-1.03a3.126,3.126,0,0,1,2.609-1.442,2.844,2.844,0,0,1,2.609,1.82v.79a10.849,10.849,0,1,0,21.7,0,10.528,10.528,0,0,0-2.747-7.176,2.7,2.7,0,0,1,1.167-3.262,2.43,2.43,0,0,1,2.609-.275A16,16,0,0,1,28.568,41.953",
    transform: "translate(-12.498 -9.886)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.8ae59295d85962382605a5354bdeb5c6.svg";
export { ForwardRef as ReactComponent };